import React from 'react';
import { MobileSelect } from '../common';

export default function AppointmentScheduleFields({
  date,
  time,
  duration,
  price,
  status,
  mode,
  hasPaymentRestriction,
  shouldSkipPayment,
  dateError,
  timeError,
  durationError,
  priceError,
  dateRef,
  timeRef,
  durationRef,
  priceRef,
  timeOptions,
  onInputChange,
  t,
}) {
  const formatTimeForDisplay = (timeString) => {
    if (!timeString) return '';
    const [hours, minutes] = timeString.split(':');
    return `${hours}:${minutes}`;
  };

  return (
    <>
      <div className="w-full min-w-0 overflow-hidden" ref={dateRef}>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          {t.date} <span className="text-red-500">*</span>
        </label>
        <input
          type="date"
          name="date"
          value={date}
          onChange={onInputChange}
          disabled={hasPaymentRestriction}
          className="block w-full min-w-0 px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-pink-500 focus:border-pink-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
          style={{ WebkitAppearance: 'none', boxSizing: 'border-box', maxWidth: '100%' }}
        />
        {dateError && <p className="mt-1 text-sm text-red-600">{dateError}</p>}
      </div>

      <div className="w-full min-w-0 overflow-hidden" ref={timeRef}>
        <MobileSelect
          label={t.time}
          value={time}
          onChange={(value) => onInputChange({ target: { name: 'time', value } })}
          options={timeOptions.map(t => ({
            value: t,
            label: formatTimeForDisplay(t)
          }))}
          placeholder={t.selectTime || 'בחר שעה'}
          error={timeError}
          required={true}
          disabled={hasPaymentRestriction}
          searchable={true}
        />
      </div>

      <div ref={durationRef}>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          {t.durationMinutes} <span className="text-red-500">*</span>
        </label>
        <input
          type="number"
          name="duration"
          value={duration}
          onChange={onInputChange}
          min="1"
          disabled={hasPaymentRestriction}
          className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-pink-500 focus:border-pink-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
        />
        {durationError && <p className="mt-1 text-sm text-red-600">{durationError}</p>}
      </div>

      {!shouldSkipPayment && (
        <div ref={priceRef}>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            {t.priceShekels} <span className="text-red-500">*</span>
          </label>
          <input
            type="number"
            name="price"
            value={price}
            onChange={onInputChange}
            min="0"
            step="0.01"
            disabled={hasPaymentRestriction}
            className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-pink-500 focus:border-pink-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
          />
          {priceError && <p className="mt-1 text-sm text-red-600">{priceError}</p>}
        </div>
      )}

      {mode === 'edit' && !shouldSkipPayment && (
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            סטטוס הפגישה
          </label>
          <select
            name="status"
            value={status}
            onChange={onInputChange}
            className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-pink-500 focus:border-pink-500"
          >
            <option value="scheduled">{t.scheduled}</option>
            <option value="completed">{t.completed}</option>
            <option value="cancelled">{t.cancelled}</option>
            <option value="no_show">{t.noShow}</option>
            <option value="no_show_justified">{t.noShowJustified}</option>
            <option value="pending_approval">{t.statusMapping.pending_approval}</option>
          </select>
        </div>
      )}
    </>
  );
}
